/**
 * Determine the stage (dev/prod) from the API URL.
 */
function getStage(): string {
  const apiUrl = import.meta.env.VITE_API_URL || '';
  if (apiUrl.includes('.dev.')) {
    return 'dev';
  }
  if (apiUrl.includes('localhost')) {
    return 'dev';
  }
  return 'prod';
}

/**
 * Get the access token from cookies.
 * The token is stored in a cookie named `accessToken-{stage}`.
 * Since the API update, this cookie is no longer httpOnly and can be read from JavaScript.
 */
export function getAccessToken(): string | null {
  const stage = getStage();
  const cookieName = `accessToken-${stage}`;

  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === cookieName) {
      return decodeURIComponent(value);
    }
  }
  return null;
}
